import { useState } from "react";
import { PBox, PSection, PText, PH1, PImg, PH2 } from "../../theme/BaseTheme";
import { keys } from "../../../config/keys";

export const MockupTypes = (props) => {
    const [displayImage, setDisplayImage] = useState(1);
    return (
        <PSection css={styles}>
            <PBox className="sell-why">
                <PBox className="sell-why-container">
                    <PText className="sell-why-subtitle">
                        Elevate Your Projects
                    </PText>
                    <PH1 className="sell-why-title">
                        Showcase Your Design in Various Mockup Templates
                    </PH1>

                    <PBox className="sell-why-reasons-wrapper">
                        <PBox>
                            {displayImage === 1 && (
                                <PImg
                                    alt="patternful ai"
                                    className={"sell-why-reasons-img"}
                                    src={keys.imageBaseUrl + "tech.jpg"}
                                />
                            )}
                            {displayImage === 2 && (
                                <PImg
                                    alt="patternful ai"
                                    className={"sell-why-reasons-img"}
                                    src={keys.imageBaseUrl + "package.jpg"}
                                />
                            )}
                            {displayImage === 3 && (
                                <PImg
                                    alt="patternful ai"
                                    className={"sell-why-reasons-img"}
                                    src={
                                        keys.imageBaseUrl + "home_and_decor.jpg"
                                    }
                                />
                            )}
                            {displayImage === 4 && (
                                <PImg
                                    alt="patternful ai"
                                    className={"sell-why-reasons-img"}
                                    src={keys.imageBaseUrl + "apparel.jpg"}
                                />
                            )}
                        </PBox>
                        <PBox className="sell-why-reasons">
                            {displayImage !== 1 && (
                                <PBox
                                    className="sell-why-reasons-item"
                                    onMouseEnter={() => {
                                        setDisplayImage(1);
                                    }}
                                >
                                    <PH2>Technology Mockups</PH2>
                                    <PText>
                                        Present your websites and apps.
                                    </PText>
                                </PBox>
                            )}
                            {displayImage === 1 && (
                                <PBox
                                    className="sell-why-reasons-item-active"
                                    onMouseEnter={() => {
                                        setDisplayImage(1);
                                    }}
                                >
                                    <PH2>Technology Mockups</PH2>
                                    <PText>
                                        Present your websites and apps.
                                    </PText>
                                </PBox>
                            )}
                            {displayImage !== 2 && (
                                <PBox
                                    className="sell-why-reasons-item"
                                    onMouseEnter={() => {
                                        setDisplayImage(2);
                                    }}
                                >
                                    <PH2>Packaging Mockups</PH2>
                                    <PText>
                                        Instant preview of your packaging.
                                    </PText>
                                </PBox>
                            )}
                            {displayImage === 2 && (
                                <PBox
                                    className="sell-why-reasons-item-active"
                                    onMouseEnter={() => {
                                        setDisplayImage(2);
                                    }}
                                >
                                    <PH2>Packaging Mockups</PH2>
                                    <PText>
                                        Instant preview of your packaging.
                                    </PText>
                                </PBox>
                            )}
                            {displayImage !== 3 && (
                                <PBox
                                    className="sell-why-reasons-item"
                                    onMouseEnter={() => {
                                        setDisplayImage(3);
                                    }}
                                >
                                    <PH2>Home & Decor Mockups</PH2>
                                    <PText>Mugs, Pillow and much more.</PText>
                                </PBox>
                            )}
                            {displayImage === 3 && (
                                <PBox
                                    className="sell-why-reasons-item-active"
                                    onMouseEnter={() => {
                                        setDisplayImage(3);
                                    }}
                                >
                                    <PH2>Home & Decor Mockups</PH2>
                                    <PText>Mugs, Pillow and much more.</PText>
                                </PBox>
                            )}
                            {displayImage !== 4 && (
                                <PBox
                                    className="sell-why-reasons-item"
                                    onMouseEnter={() => {
                                        setDisplayImage(4);
                                    }}
                                >
                                    <PH2>Apparel Mockups</PH2>
                                    <PText>
                                        Showcase your clothing line or brand.
                                    </PText>
                                </PBox>
                            )}
                            {displayImage === 4 && (
                                <PBox
                                    className="sell-why-reasons-item-active"
                                    onMouseEnter={() => {
                                        setDisplayImage(4);
                                    }}
                                >
                                    <PH2>Apparel Mockups</PH2>
                                    <PText>
                                        Showcase your clothing line or brand.
                                    </PText>
                                </PBox>
                            )}
                        </PBox>
                    </PBox>
                </PBox>
            </PBox>
        </PSection>
    );
};

const styles = {
    "& .sell-why": {
        padding: "0 1.5rem",
        maxWidth: "80rem",
        margin: "8rem auto",
        "@bp2": { marginTop: "10rem" },
        "@bp4": { paddingLeft: "2rem", paddingRight: "2rem" },
    },
    "& .sell-why-container": {
        position: "relative",
    },
    "& .sell-why-subtitle": {
        color: "$colors$primary",
        lineHeight: "1.75rem",
        fontWeight: "600",
        fontSize: "1rem",
        textAlign: "center",
    },
    "& .sell-why-title": {
        color: "rgb(17 24 39)",
        fontWeight: "700",
        fontSize: "1.875rem",
        lineHeight: "2.25rem",
        marginTop: "0.5rem",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        "@bp2": { fontSize: "2.25rem", lineHeight: "2.5rem" },
    },
    "& .sell-why-text": {
        fontSize: "20px",
        lineHeight: "1.7",
        color: "#293745",
        textAlign: "center",
        width: "60%",
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: "80px",
    },
    "& .sell-why-reasons-wrapper": {
        display: "flex",
        justifyContent: "space-between",
        gap: "2rem",
        alignItems: "center",
        maxWidth: "42rem",
        marginLeft: "auto",
        marginRight: "auto",
        flexDirection: "column",
        "@bp4": { flexDirection: "row", gap: "4rem", maxWidth: "56rem" },
    },
    "& .sell-why-reasons-img": {
        objectFit: "cover",
        borderRadius: "1rem",
        height: "32rem",
        aspectRatio: "4/4",
        width: "auto",
        margin: "1.5rem auto",
        border: "1px solid $colors$borderColor",
    },
    "& .sell-why-reasons": {
        width: "100%",
        "@bp4": { flex: "1 1 auto", maxWidth: "36rem" },
    },
    "& .sell-why-reasons-item": {
        padding: "0.5rem 1rem",
        margin: "0 2rem",
        borderBottom: "1px solid $colors$borderColor",
        "& h2": {
            color: "rgb(17 24 39)",
            fontWeight: "600",
            fontSize: "1.125rem",
            lineHeight: "1.5rem",
            width: "100%",
        },
        "& p": {
            color: "rgb(75 85 99)",
            lineHeight: "1.5rem",
            fontSize: "1rem",
            width: "100%",
            marginTop: "0.5rem",
        },
        "@bp4": { margin: "0" },
    },
    "& .sell-why-reasons-item-active": {
        padding: "0.5rem 1rem",
        margin: "0 2rem",
        borderBottom: "1px solid $colors$borderColor",
        backgroundColor: "$colors$lightPrimary",
        "& h2": {
            color: "$colors$primary",
            fontWeight: "600",
            fontSize: "1.125rem",
            lineHeight: "1.5rem",
            width: "100%",
        },
        "& p": {
            color: "$colors$primary",
            lineHeight: "1.5rem",
            fontSize: "1rem",
            width: "100%",
            marginTop: "0.5rem",
        },
        "@bp4": { margin: "0" },
    },
};
